import React from 'react';
import { Text } from '@carnica/ui-kit';
import { EShortFooterTheme } from "../../store/slices/layout";
import { Metric } from "../../metric";
import { connector } from "./connector";
var _SiteMapText = function _SiteMapText(_ref) {
  var siteMapHref = _ref.siteMapHref,
    copyright = _ref.copyright,
    siteMapText = _ref.siteMapText,
    theme = _ref.theme;
  var currentYear = new Date().getFullYear().toString();
  var formattedCopyright = copyright.replace(/\{year\}/g, currentYear);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      link_text: siteMapText,
      link_url: siteMapHref
    }),
    events: {
      shortFooterMetric: ['handleClickLink']
    },
    mode: "click",
    "data-t-id": "components-SiteMapText"
  }, /*#__PURE__*/React.createElement(Text, {
    color: theme === EShortFooterTheme.dark ? 'primary-invert' : 'primary',
    href: siteMapHref,
    size: "2xs",
    tagName: "a",
    "data-t-id": "components-SiteMapText"
  }, siteMapText)), /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    size: "2xs"
  }, formattedCopyright));
};
export var SiteMapText = connector(_SiteMapText);